import { Button, Box, TextField } from "@mui/material";
import { Refresh } from "@mui/icons-material";

const TableFilter = ({
  options = [],
  selectedValue,
  onChange,
  startDate,
  endDate,
  onDateChange,
  onClearFilters,
  showDate = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        mt: 3,
        gap: 2,
        mb: 2,
        flexWrap: "wrap",
        width: "100%"
      }}
    >
      {/* Toggle Buttons */}
      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          width: { xs: "100%", sm: "auto" },
          justifyContent: { xs: "flex-start", sm: "flex-start" },
          overflowX: { xs: "auto", sm: "visible" },
          pb: { xs: 0.5, sm: 0 },
          "&::-webkit-scrollbar": { display: "none" }
        }}
      >
        {options.map((item) => {
          const isActive = selectedValue === item;
          return (
            <Button
              key={item}
              variant="text"
              onClick={() => onChange(item)}
              sx={{
                textTransform: "capitalize",
                fontWeight: isActive ? 600 : 500,
                fontFamily: "Be Vietnam Pro",
                fontSize: "14px",
                color: "#000",
                minWidth: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                whiteSpace: "nowrap",
                borderBottom: isActive
                  ? "2px solid #002865"
                  : "none",
                borderRadius: 0,
                px: { xs: 1, sm: 2 }
              }}
            >
              {item}
            </Button>
          );
        })}
      </Box>

      {/* Spacer — Collapses cleanly on mobile layout */}
      <Box sx={{ display: { xs: "none", sm: "block" }, flexGrow: 1 }} />

      {/* Date Filters */}
      {showDate && (
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            width: { xs: "100%", sm: "auto" }, // Spans across mobile width smoothly
          }}
        >
          <TextField
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => onDateChange("start", e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }} // Splits room 50/50 on phone screens
          />
          <TextField
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => onDateChange("end", e.target.value)}
            size="small"
            inputProps={{ min: startDate }}
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }} // Splits room 50/50 on phone screens
          />
        </Box>
      )}

      {/* Clear Button */}
      <Button
        variant="contained"
        onClick={onClearFilters}
        sx={{
          ml: { xs: 0, sm: 1 }, // Removes left margin displacement on stacked mobile grids
          mt: 0,
          width: { xs: "100%", sm: "auto" }, // Maximizes touch footprint across the mobile track
          fontFamily: "Be Vietnam Pro",
          background: "#ECF4FF",
          color: "#000",
          boxShadow: "none",
          display: "flex",
          gap: 1, // Adds standard separation layout space before the refresh icon node
          '&:hover': {
            background: "#ECF4FF",
          }
        }}
      >
        Clear <Refresh fontSize="small" />
      </Button>
    </Box>
  );
};

export default TableFilter;